/**
 * サービス一覧ページ（/service/）で URL のハッシュ（#production, #lecture, #consulting）に
 * 1回だけスクロールする。
 *
 * 根本原因と対策:
 * - ScrollTrigger.refresh() を呼ぶと、scrub 付きアニメのリセットでスクロール位置が
 *   「制作」付近に戻る（GSAP 仕様）。refresh() は呼ばない。
 * - グローバルな scroll-behavior: smooth と競合しないよう、スクロール直前だけ auto にする。
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
 */
const SERVICE_ANCHOR_IDS = [ 'production', 'lecture', 'consulting' ];
const LOADER_WAIT_MS = 2500;

function isServicePage() {
  const pathname = window.location.pathname || '';
  const base = pathname.replace( /\/$/, '' );
  return base === '/service' || base.endsWith( '/service' );
}

function getTargetElement() {
  const hash = window.location.hash ? window.location.hash.slice( 1 ) : '';
  if ( !hash || !SERVICE_ANCHOR_IDS.includes( hash ) ) return null;
  return document.getElementById( hash );
}

function performScroll() {
  const el = getTargetElement();
  if ( !el ) return;
  var html = document.documentElement;
  var prevBehavior = html.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  el.scrollIntoView( { behavior: 'instant', block: 'start' } );
  html.style.scrollBehavior = prevBehavior;
}

/**
 * ローダー完了を待つ（body の is-loading が外れるか、最大 LOADER_WAIT_MS で打ち切り）
 */
function whenLoaderDone( callback ) {
  if ( !document.body.classList.contains( 'is-loading' ) ) {
    requestAnimationFrame( callback );
    return;
  }
  var observer = new MutationObserver( function () {
    if ( !document.body.classList.contains( 'is-loading' ) ) {
      observer.disconnect();
      requestAnimationFrame( callback );
    }
  } );
  observer.observe( document.body, { attributes: true, attributeFilter: [ 'class' ] } );
  setTimeout( function () {
    observer.disconnect();
    callback();
  }, LOADER_WAIT_MS );
}

function runScrollOnce() {
  requestAnimationFrame( function () {
    requestAnimationFrame( performScroll );
  } );
}

/**
 * 同一ページ内でハッシュが変わったときに該当セクションへスクロールする。
 * ドロワー内のリンククリックでは scroll は drawer 側で行うため、ここではスキップする。
 */
function onHashChange() {
  if ( !isServicePage() ) return;
  if ( window.__mjServiceAnchorFromDrawer ) {
    window.__mjServiceAnchorFromDrawer = false;
    return;
  }
  const el = getTargetElement();
  if ( !el ) return;
  setTimeout( function () {
    performScroll();
  }, 80 );
}

function init() {
  if ( !isServicePage() ) return;

  // 初回ロード時（URL にハッシュがある場合）のスクロール
  if ( getTargetElement() ) {
    function start() {
      if ( document.readyState !== 'complete' ) {
        window.addEventListener( 'load', function onLoad() {
          window.removeEventListener( 'load', onLoad );
          whenLoaderDone( runScrollOnce );
        } );
        return;
      }
      whenLoaderDone( runScrollOnce );
    }

    if ( document.readyState === 'loading' ) {
      document.addEventListener( 'DOMContentLoaded', start );
    } else {
      start();
    }
  }

  // 同一ページ内でハッシュが変わったとき（例: スマホドロワーで「レクチャー」をタップ）
  window.addEventListener( 'hashchange', onHashChange );
}

if ( document.readyState === 'loading' ) {
  document.addEventListener( 'DOMContentLoaded', init );
} else {
  init();
}
